<template>
  <a-modal
      title="补抽专家"
      :visible="visible"
      :maskClosable="false"
      :width="1280"
      destroyOnClose
      @ok="onSave"
      @cancel="$emit('cancel')"
      :confirmLoading="loading">
    <span style="float: right;font-size: 20px;color: red">当前还能补抽{{redrawExpertNum}}人</span>
    <!--           <---------------------采购品目选择--------------------------------->
    <PurchaseForm ref="purchaseRef" :purchaseForm="purchaseForm" :apply-id="applyId"/>
  </a-modal>
</template>

<script>
import PurchaseForm from '@/epp/expertmain/selectexpertapply/common/itemform/PurchaseForm.vue'
import { formWaring } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import { RedrawExpert } from '@/epp/expertmain/selectexpertapply/api/ExpertApplyRequest'

export default {
  name: 'RedrawExpertModal',
  components: { PurchaseForm },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    applyId: {
      type: String,
      default: ''
    },
    redrawExpertNum:{
      type:Number,
      default:0
    }
  },
  data () {
    return {
      purchaseForm: {
        data: []
      },
      loading: false,
    }
  },
  methods: {
    //初始化数据
    initData (data) {
      this.form = { ...data }
    },
    //回传输入的值
    onSave () {
      let that = this
      that.$refs.purchaseRef.$refs.purchaseFormRef.validate((valid, err) => {
        formWaring(err, valid)
        if (valid) {
              if (that.purchaseForm.data.length === 0) {
                that.$message.warning('请至少选择一个采购品目')
                return
              }
              let num = that.purchaseForm.data.reduce(function (prev, cur) {
                return prev + cur.applyNum;
              }, 0)
              if (num>this.redrawExpertNum){
                that.$message.warning('最多只能再补抽'+this.redrawExpertNum+'人')
                return
              }
              let data = {}
              data.expertItemList = [...that.purchaseForm.data]
              data.applyId = that.applyId
              that.doRedrawExpert(data)
            }
      })
    },
    async doRedrawExpert (data) {
      try {
        this.loading = true
        let res = await RedrawExpert(data)
        if (200 !== res.code) {
          this.$message.error('补抽失败')
          return
        }
        this.$message.success('补抽成功')
        this.purchaseForm = {
          data: []
        }
        this.$emit('success',res.result)
      } catch (e) {
        this.$message.error(e.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
